import React from 'react';
import moment from "moment";
import Snackbar from '@mui/material/Snackbar';
import {Typography, Box} from '@mui/material';
import rightTick from '../../assets/img/rightTick.png';
import {isEmpty} from "../../utils/validations";

const EventsView = (props) => {
    const {isMobileView, events, open, vertical, horizontal, handleClose, copyToClipboard} = props;
    const eventsRecord = isEmpty(events) ? [] : events.slice(0, 3);

    return (
        <div className="col-lg-4 col-md-12">
            <div className="knowledge-bank-sub-container">
                <div className="knowledge-bank-header-box">
                    <h3 className="knowledge-bank-sub-container-header">Events</h3>
                    <div className={isMobileView ? "d-none" : "d-block"}>
                        <a href={"/knowledge-bank/events"}>
                            <button className="btn btn-outline-dark ">View More</button>
                        </a>
                    </div>
                </div>

                {eventsRecord.map((e, index) =>
                    <div className="d-flex pb-5" key={index}>
                        <div className="img-blog cursor">
                            <iframe src={e.url}
                                    width="161"
                                    height={"100%"}
                                    style={{aspectRatio: 16 / 9}}
                                    allowFullScreen={true}
                                    className="blog_img img-fluid">
                            </iframe>
                        </div>
                        <div className="text-start w-100 ps-3">
                            <p className="blog-text blog-text-truncate mb-0">
                                {e.title}
                            </p>
                            <div className="date-container mt-1 d-flex align-items-center justify-content-between">
                                <div>
                                    <i className="fa-regular fa-calendar"/>
                                    &nbsp; {moment(e.created_at).format("MMM D, YYYY")}
                                </div>
                                <i className="fa-regular fa-copy cursor"
                                   onClick={() => copyToClipboard(e.url)}
                                />
                            </div>
                        </div>
                    </div>
                )}

                {isMobileView ?
                    <div className="text-center mt-5">
                        <a href={"/knowledge-bank/events"}>
                            <button className="btn btn-outline-dark ">View More</button>
                        </a>
                    </div> : ''
                }
            </div>

            <Snackbar
                anchorOrigin={{vertical, horizontal}}
                autoHideDuration={2000}
                open={open}
                onClose={handleClose}
                message={<Box display="flex" alignItems="center">
                    <img src={rightTick} alt="Right Tick" style={{marginRight: 10, width: 25, height: 20}}/>
                    <Typography sx={{color: 'white', fontSize: 18, fontFamily: 'Poppins'}}>Link Copied!</Typography>
                </Box>
                }
                sx={{
                    '& .MuiSnackbarContent-root': {
                        backgroundColor: '#51A351',
                        width: '330px',
                    }
                }}
                key={vertical + horizontal}
            />
        </div>
    );
};

export default EventsView;
